<template>
    <div class="h-screen flex bg-gray-200">
        <shop-sidebar ref="shopSidebarRef" />

        <div class="flex-1 flex flex-col">
            <app-top-bar ref="appTopBarRef" />

            <main
                class="flex-1 max-h-[calc(100vh-5rem)] overflow-y-auto mt-[-3rem] z-10 overflow-hidden"
            >
                <div
                    class="flex-1 mx-auto overflow-y-auto px-6 text-gray-700 dark:text-gray-500 transition duration-500 ease-in-out"
                    :style="{
                        maxWidth: '1366px',
                        width: 'calc(100vw - 16rem)',
                    }"
                >
                    <template v-if="checkApi">
                        <template
                            v-if="
                                !user?.shop?.data?.paper_uploaded_full &&
                                !user?.shop?.data?.paper_verified
                            "
                        >
                            <div
                                class="shadow-2xl shadow-indigo-500 flex p-4 mb-4 bg-yellow-100 rounded-lg dark:bg-yellow-200"
                                role="alert"
                            >
                                <svg
                                    class="flex-shrink-0 w-5 h-5 text-yellow-700 dark:text-yellow-800"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                        clip-rule="evenodd"
                                    ></path>
                                </svg>
                                <div
                                    class="ml-3 text-sm font-medium text-yellow-700 dark:text-yellow-800"
                                >
                                    {{ $t("text.notification_upload") }}
                                    <button
                                        @click="router.push('/user/profile')"
                                        class="font-semibold underline hover:text-yellow-800 dark:hover:text-yellow-900"
                                    >
                                        {{ $t("text.click_here") }}</button
                                    >,
                                    {{
                                        $t("text.time_remaining", {
                                            day: dateTimeFormat(
                                                user?.shop?.data
                                                    ?.paper_verify_expire_at
                                            ),
                                        })
                                    }}
                                </div>
                            </div>
                        </template>
                        <div v-if="showWarning === 'true'">
                            <div v-if="shopSidebarRef?.user">
                                <div
                                    v-if="
                                        shopSidebarRef?.user &&
                                        !shopSidebarRef?.user.have_bank
                                    "
                                    class="shadow-2xl shadow-indigo-500 flex p-4 mb-4 bg-yellow-100 rounded-lg dark:bg-yellow-200"
                                    role="alert"
                                >
                                    <svg
                                        class="flex-shrink-0 w-5 h-5 text-yellow-700 dark:text-yellow-800"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                            clip-rule="evenodd"
                                        ></path>
                                    </svg>
                                    <div
                                        class="ml-3 text-sm font-medium text-yellow-700 dark:text-yellow-800"
                                    >
                                        {{ $t("text.add_your_bank") }}
                                        <button
                                            @click="onOpenCreateBankDialog"
                                            class="font-semibold underline hover:text-yellow-800 dark:hover:text-yellow-900"
                                        >
                                            {{ $t("text.click_here") }}
                                        </button>
                                    </div>
                                    <button
                                        type="button"
                                        @click="onCloseWarning"
                                        class="ml-auto -mx-1.5 -my-1.5 bg-yellow-100 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex h-8 w-8 dark:bg-yellow-200 dark:text-yellow-600 dark:hover:bg-yellow-300"
                                        data-collapse-toggle="alert-4"
                                        aria-label="Close"
                                    >
                                        <span class="sr-only">Close</span>
                                        <svg
                                            class="w-5 h-5"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-if="showUpdatePassword === 'true'">
                            <div v-if="result > 180">
                                <div
                                    id="alert-4"
                                    class="shadow-2xl shadow-indigo-500 flex p-4 mb-4 bg-yellow-100 rounded-lg dark:bg-yellow-200"
                                    role="alert"
                                >
                                    <svg
                                        class="flex-shrink-0 w-5 h-5 text-yellow-700 dark:text-yellow-800"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                                            clip-rule="evenodd"
                                        ></path>
                                    </svg>
                                    <div
                                        class="ml-3 text-sm font-medium text-yellow-700 dark:text-yellow-800"
                                    >
                                        {{ $t("text.update_password_180") }}
                                        <button
                                            @click="onOpenUpdateForm(user.id)"
                                            class="font-semibold underline hover:text-yellow-800 dark:hover:text-yellow-900"
                                        >
                                            {{ $t("text.click_here") }}
                                        </button>
                                        {{ $t("text.or") }}
                                        <button
                                            @click="
                                                onCloseUpdatePassword(user.id)
                                            "
                                            class="font-semibold underline hover:text-yellow-800 dark:hover:text-yellow-900"
                                        >
                                            {{ $t("text.ignore") }}
                                        </button>
                                    </div>
                                    <button
                                        type="button"
                                        @click="setShowUpdatePassword(false)"
                                        class="ml-auto -mx-1.5 -my-1.5 bg-yellow-100 text-yellow-500 rounded-lg focus:ring-2 focus:ring-yellow-400 p-1.5 hover:bg-yellow-200 inline-flex h-8 w-8 dark:bg-yellow-200 dark:text-yellow-600 dark:hover:bg-yellow-300"
                                        data-collapse-toggle="alert-4"
                                        aria-label="Close"
                                    >
                                        <span class="sr-only">Close</span>
                                        <svg
                                            class="w-5 h-5"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <router-view />
                </div>
            </main>
        </div>
        <dialog-bank
            ref="dialogBankRef"
            @created="onCreateBankAccountSuccess"
        ></dialog-bank>
        <dialog-change-password
            ref="updatePasswordRef"
        ></dialog-change-password>
        <dialog-ignore-password ref="ignorePasswordRef">
        </dialog-ignore-password>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from "vue";
import DialogBank from "../views/users/DialogBank.vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useI18n } from "vue-i18n";
import DialogChangePassword from "../views/users/DialogChangePassword.vue";
import userApi from "../api/user";
import DialogIgnorePassword from "../views/users/DialogIgnorePassword.vue";

import ShopSidebar from "./Sidebar/ShopSidebar.vue";
import { useRouter } from "vue-router";
import { useDate } from "../Hook/useDate";
import AppTopBar from "./Topbar/AppTopBar.vue";

export default defineComponent({
    components: {
        ShopSidebar,
        DialogBank,
        DialogChangePassword,
        DialogIgnorePassword,
        AppTopBar,
    },
    setup() {
        const toast = useToast();
        const { t } = useI18n({ useScope: "global" });
        const shopSidebarRef = ref("");
        const showWarning = ref(localStorage.getItem("showWarning"));
        const showUpdatePassword = ref(
            localStorage.getItem("showUpdatePassword")
        );
        const result = ref("");
        const dateNow = new Date().getTime();
        const dialogBankRef = ref(null);
        const router = useRouter();
        const store = useStore();
        const { dateTimeFormat } = useDate();
        const myBanks = computed(() => store.state.bank.myBanks);
        const user = ref({});
        const checkApi = ref(false);
        const check = ref(false);
        const getInfo = async function () {
            const { data } = await userApi.getUserInfo(
                `?include=photo,default_store,shop`
            );
            user.value = data.data;
            checkApi.value = true;
            if (
                user.value.password_updated_at ||
                user.value.password_ignored_at
            ) {
                if (user.value.password_updated_at) {
                    if (
                        user.value.password_ignored_at &&
                        user.value.password_ignored_at >
                            user.value.password_updated_at
                    ) {
                        var passwordUpdatedAt = user.value.password_ignored_at;
                    } else {
                        var passwordUpdatedAt = user.value.password_updated_at;
                    }
                } else {
                    var passwordUpdatedAt = user.value.password_ignored_at;
                }
                const date = new Date(passwordUpdatedAt).getTime();
                result.value = Math.round(
                    (dateNow - date) / (1000 * 3600 * 24)
                );
                console.log(result.value);
            } else {
                result.value = 181;
            }
            if (data) {
                check.value = true;
            }
        };

        onMounted(() => {
            if (localStorage.getItem("access_token")) {
                getInfo();
            }
        });
        const updatePasswordRef = ref("");
        const onOpenUpdateForm = async function (id) {
            updatePasswordRef.value.onOpen(id);
            setShowUpdatePassword(false);
        };

        const setShowWarning = function (value) {
            showWarning.value = value;
            localStorage.setItem("showWarning", value);
        };

        const onCloseWarning = function () {
            setShowWarning(false);
        };

        const ignorePasswordRef = ref("");
        const onCloseUpdatePassword = async function (id) {
            ignorePasswordRef.value.onOpen(id);
            setShowUpdatePassword(false);
        };

        const setShowUpdatePassword = function (value) {
            showUpdatePassword.value = value;
            localStorage.setItem("showUpdatePassword", value);
        };

        const onOpenCreateBankDialog = () => {
            const countAcc = myBanks.value.length;
            dialogBankRef.value.setupDialog("create", countAcc);
        };

        const onCreateBankAccountSuccess = function () {
            setShowWarning(false);
            toast.success(t("text.create_bank_success"));
        };

        return {
            shopSidebarRef,
            showWarning,
            onCloseWarning,
            onOpenCreateBankDialog,
            dialogBankRef,
            updatePasswordRef,
            onCreateBankAccountSuccess,
            onOpenUpdateForm,
            result,
            onCloseUpdatePassword,
            showUpdatePassword,
            ignorePasswordRef,
            user,
            setShowUpdatePassword,
            router,
            check,
            dateTimeFormat,
            checkApi,
        };
    },
});
</script>
